import { useEffect, useState } from "react"

export default function useAlreadySaafeUser({ apiBaseUrl, hasPermission }) {
  const [alreadySaafeUser, setAlreadySaafeUser] = useState(false)

  useEffect(() => {
    const getIsEnabled = async () => {
      const response = await fetch(`${apiBaseUrl}/features/FEATURE_saafe_user`, {
        credentials: "include"
      })
      return (await response.json()).data.attributes.enabled
    }
    if (hasPermission) {
      getIsEnabled().then(enabled => {
        setAlreadySaafeUser(enabled)
      })
    }
  }, [])

  return alreadySaafeUser
}
